<template>
  <div class="SSPDTable">
    <v-container grid-list-md fluid fill-height>
      <v-layout
        justify-center
        align-center
      >
        <v-flex md10>
          <v-card class="mb-2">
            <v-card-title class="title">
              Avance por Territorio
              <v-spacer/>
              <v-btn
                color="info"
                @click="changeData()"
              >
                <span>{{territorio}}</span>
              </v-btn>

              <v-card-actions>
                <v-btn color="info" :disabled="dataVals === null">
                  <download-csv
                    v-if="table"
                    :data="dataVals"
                    name="'Avance por Territorio (Departamento).csv'"
                    :labels="labelsDept"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                  <download-csv
                    v-else
                    :data="dataVals"
                    name="'Avance por Territorio (Municipio).csv'"
                    :labels="labelsMunic"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <data-table
                v-if="table"
                :headers="headersDept"
                :dataVals="dataVals"
                :searchActive="true"
                :key="tableKey"
              />
              <data-table
                v-else
                :headers="headersMunic"
                :dataVals="dataVals"
                :searchActive="true"
                :key="tableKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import dataTable from '@/components/Tables/TableExpandWithTotals'
import JsonCSV from 'vue-json-csv'

export default {
  name: 'SSPDTable',

  components: {
    'data-table': dataTable,
    'download-csv': JsonCSV
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.loadTable()
  },

  data: function () {
    return {
      backConf: {
        path: '/projects/ssdp_tb/',
        page: 1
      },

      loading: false,
      loadingDept: false,
      progressSize: 70,
      progressWidth: 7,

      table: true,

      headersDept: [
        {
          text: 'Departamentos',
          align: 'left',
          value: 'zona',
          str: 'Totales'
        },
        { text: 'Total', value: 'total', align: 'center' }
      ],
      labelsDept: {
        'zona': 'Departamentos',
        'total': 'Total'
      },

      headersMunic: [
        {
          text: 'Municipios',
          align: 'left',
          value: 'zona',
          str: 'Totales'
        },
        { text: 'Total', value: 'total', align: 'center' }
      ],
      labelsMunic: {
        'zona': 'Municipios',
        'total': 'Total'
      },

      dataVals: null,
      tableKey: 0
    }
  },

  computed: {
    /** Cambia el nombre del boton, de carga
     */
    territorio () {
      return this.table ? 'Cambiar a Municipio' : 'Cambiar a Departamento'
    }
  },

  methods: {
    /** Carga la tabla
     */
    loadTable () {
      this.loading = true
      this.dataVals = null
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          zona: this.table ? 'departamento' : 'municipio'
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals = resp.data
          t.loading = false
          t.tableKey += 1
        })
        .catch(function (err) {
          t.dataVals = []
          t.loading = false
          console.error(err)
        })
    },

    /** Cambia la base territorial
     */
    changeData () {
      this.table = !this.table
      this.loadTable()
    }
  }
}
</script>
